import { SettingsPermissions } from "@redotech/account-common/permissions";
import { directMerchantAccess } from "../../settings-catalog/access";
import type {
  SettingGroupDefinition,
  SettingOwner,
  SettingRisk,
} from "../../settings-catalog/types";

export type BrandKitFlatTeamSettingGroupId = "brand_kit.images";

const owner: SettingOwner = {
  kind: "teamSettings",
  path: "settings.brandkit",
  product: "general",
};

const risk: SettingRisk = {
  level: "medium",
  reason:
    "Appears on customer-facing emails and portals sent in the merchant's name.",
};

export const BrandKitFlatTeamSettingGroups = [
  {
    id: "brand_kit.images",
    title: "Brand kit",
    description:
      "The merchant's brand assets, used to brand the emails and portals Redo sends on their behalf.",
    productArea: "general",
    access: directMerchantAccess(SettingsPermissions.SET_GENERAL_SETTINGS),
    owner,
    risk,
    agentEditability: { mode: "requiresApproval" },
    fullPageTarget: { type: "settings", path: "brand-kit" },
    synonyms: ["brand logo", "brand kit", "store logo"],
  },
] as const satisfies readonly SettingGroupDefinition<BrandKitFlatTeamSettingGroupId>[];

export const BrandKitFlatTeamSettingGroupById = (() => {
  const map: Record<
    string,
    SettingGroupDefinition<BrandKitFlatTeamSettingGroupId>
  > = {};
  for (const group of BrandKitFlatTeamSettingGroups) {
    map[group.id] = group;
  }
  return map as Record<
    BrandKitFlatTeamSettingGroupId,
    SettingGroupDefinition<BrandKitFlatTeamSettingGroupId>
  >;
})();
